import { handleGetRequest, handlePostRequest, handlePutRequest } from '.';
import { URI } from '../../constants/URI';
import { warningToast } from '../../utils/toast';
import { setActiveUser, setGroupMessages, setGroupMessagesPagination, setMessage, setMessagesPagination } from '../slices/messageSlice';
import { store } from '../store';

export const getMessages = async (id, loading = true, page) => {
  const res = await handleGetRequest(URI.get_messages(id), null, {
    loading,
    params: {
      page,
    },
  });
  if (res?.ack) {
    store.dispatch(setMessage(res.messages));
    store.dispatch(setMessagesPagination(res.pagination));
    store.dispatch(setActiveUser(res?.user));
  } else {
    window.location.href = '/';
  }
  return res;
};

export const sentMessage = async (body) => {
  const res = await handlePostRequest(
    URI.sent_message,
    { body },
    {
      loading: false,
    }
  );
  return res;
};

export const handleMarkAsRead = async (id) => {
  const res = await handlePutRequest(URI.mark_as_read(id), null, {
    loading: false,
    toast: false,
  });
  return res;
};

export const handleUpdateFile = async (body) => {
  const res = await handlePutRequest(URI.update_file, body, {
    toast: false,
  });
  if (res?.ack) getMessages(body?.contact_id);
  return res;
};

export const sentGroupMessage = async (group_id, body) => {
  const res = await handlePostRequest(
    URI.sent_group_message(group_id),
    { body },
    {
      loading: false,
    }
  );

  if (res?.skipped_contacts?.length > 0) {
    const skippedNames = res.skipped_contacts.map(c => c.name).join(', ');
    warningToast(
      `Message could not be delivered to ${skippedNames} due to the 24-hour policy.`
    );
  }

  return res;
};

export const getGroupMessages = async (group_id, loading = true, page) => {
  const res = await handleGetRequest(URI.get_group_messages(group_id), null, {
    loading,
    params: {
      page,
    },
  });
  if (res?.ack) {
    store.dispatch(setGroupMessages(res.messages));
    store.dispatch(setGroupMessagesPagination(res.pagination));
  }
  return res;
};

export const getSendMessageToGroup = async (batch_id) => {
  const res = await handleGetRequest(URI.group_message_send_to(batch_id));
  return res;
};

export const markUnread = async (contact_id) => {
  const res = await handlePutRequest(URI.mark_unread(contact_id), null, {
    toast: false,
  });
  return res;
};